var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlpFooterTikTokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 19.6328C27.168 19.668 25.6914 19.1758 24.4258 18.2617V24.5547C24.4258 26.9453 22.9492 29.0547 20.6992 29.8984C18.4844 30.7422 15.9531 30.1094 14.4062 28.3164C12.8242 26.4883 12.543 23.9219 13.668 21.8125C14.793 19.7383 17.1133 18.5781 19.5039 18.8945V22.0586C18.4141 21.707 17.2188 22.0938 16.5508 23.0078C15.918 23.957 15.918 25.1875 16.5859 26.1016C17.2539 27.0156 18.4492 27.4023 19.5039 27.0508C20.5938 26.6992 21.332 25.6797 21.332 24.5547V12.25H24.4258C24.4258 12.5312 24.4258 12.7773 24.4961 13.0586C24.707 14.2188 25.375 15.2383 26.3945 15.8711C27.0625 16.3281 27.9062 16.5742 28.75 16.5742V19.6328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpFooterTikTokIcon);
export default __webpack_public_path__ + "static/media/DlpFooterTikTokIcon.db6b00b9b3634aee0737a97be9401ccc.svg";
export { ForwardRef as ReactComponent };